export const styles = {
  inputRoot: {
    '& .MuiFormControl-root': {
      marginTop: '10px',
      borderRadius: '5px'
    }
  }
};
